import { supabase } from './supabase';

export const listAdvances = async ({ month, employeeId } = {}) => {
  let q = supabase.from('salary_advances').select('*, employee:profiles!salary_advances_employee_id_fkey(id,name,avatar)').order('created_at', { ascending: false });
  if (month) q = q.eq('month', month);
  if (employeeId) q = q.eq('employee_id', employeeId);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
};

// Empleado: pide un adelanto (queda pendiente hasta que el administrador decida).
export const requestAdvance = async ({ employeeId, amount, month, note }) => {
  const { error } = await supabase.from('salary_advances').insert({
    employee_id: employeeId, amount: Number(amount), month, note: note || null,
    status: 'pending', requested_by_employee: true,
  });
  if (error) throw error;
};

// Administrador: carga un adelanto ya pagado (queda aprobado).
export const addAdvance = async ({ employeeId, amount, month, paidOn, note, adminId }) => {
  const { error } = await supabase.from('salary_advances').insert({
    employee_id: employeeId, amount: Number(amount), month, paid_on: paidOn, note: note || null,
    status: 'paid', decided_by: adminId, decided_at: new Date().toISOString(),
    paid_at: new Date().toISOString(), paid_by: adminId,
  });
  if (error) throw error;
};

export const decideAdvance = async (id, status, adminId) => {
  const { error } = await supabase.from('salary_advances')
    .update({ status, decided_by: adminId, decided_at: new Date().toISOString() }).eq('id', id);
  if (error) throw error;
};

export const removeAdvance = async (id) => {
  const { error } = await supabase.from('salary_advances').delete().eq('id', id);
  if (error) throw error;
};

export const markAdvancePaid = async (id, adminId, paid = true) => {
  const { error } = await supabase.from('salary_advances')
    .update(paid ? { status: 'paid', paid_at: new Date().toISOString(), paid_by: adminId } : { status: 'approved', paid_at: null, paid_by: null }).eq('id', id);
  if (error) throw error;
};
